import React from 'react';
import {Divider, Header, Segment, Button, Message, Label, Icon} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const FormsRegisterComplete = (props) => {
    const {updateStepIndex} = props;
    return (
        <Segment>
            <Header as='h2'>
                Completed!
            </Header>
            <Divider />
            <Message positive>
                <Message.Header>
                    <Icon name='thumbs up outline'/> 
                    Congratulations!
                </Message.Header>
                <p>
                    Registration is complete. You may start using the Portal!
                </p>
            </Message>
            &nbsp;
            <Link to="/app">
                <Button positive fluid size="huge">Let's Go!</Button>
            </Link>
        </Segment>
    );
}

export default FormsRegisterComplete;